import React, { useEffect, useState } from 'react';
import { getStreamsProductName } from '../../../apiclients/CommonUtils';

function MultiFactorAuth({  register, errors }) {
    const streamsProductName = getStreamsProductName();
    return (
        <>
            {/* <div className="general-settings pb-3">
                Multi Factor Authentication
            </div> */}
            <div className="add-numbermain mt-0">
                <div className="tel-numbers fw-500">
                    MFA For Every Login <br />

                    <p className="mt-1 mb-0 w-80 phrecording">
                        <strong>Note:</strong> When enabled this setting, user must enter username and password followed by MFA code for every login. This is applicable to all desktop applications like Browser, Windows and Mac {streamsProductName} and Softphone clients and to the admin portal.
                    </p>
                </div>
                <div>
                    <div className=" ">
                        <label className="switch">
                            <input
                                className="form-control"
                                type="checkbox"
                                {...register("mfa_login")}
                            />
                            {errors.global_settings?.security?.mfa_login && (
                                <p className="text-danger">{errors.global_settings?.security.mfa_login.message}</p>
                            )}
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
           
        </>
    )
}

export default MultiFactorAuth
